import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-panja-bottom-sheet',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './panja-bottom-sheet.component.html',
  styleUrl: './panja-bottom-sheet.component.scss'
})
export class PanjaBottomSheetComponent implements OnInit {
   constructor(
    private bottomSheetRef: MatBottomSheetRef<PanjaBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) {}

    renewDue = new FormControl(true)
    isCheck: boolean = false
  
  ngOnInit(): void {
    
  }
  check(){
    this.isCheck = true
  }
}
